module.exports = __webpack_public_path__ + "img/mall_img1.0d76247d.png";